module.exports = __webpack_public_path__ + "static/DBPortrait-067eda22071b01ea24ba5d2e32277293.jpg";